import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import rootReducer from './ducks'

const middlewares = [thunk];

const isDevelopment = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

const composeEnhancers = isDevelopment ? (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose) : compose;

const store = createStore(
  rootReducer, 
  composeEnhancers(applyMiddleware(...middlewares)), 
);

export default store;
